export default __webpack_public_path__ + "fa8571b061733788e9679be5f8b3e6a7.ttf";